import { render, staticRenderFns } from "./PendingCard.vue?vue&type=template&id=60dbf3ab"
import script from "./PendingCard.vue?vue&type=script&lang=js"
export * from "./PendingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports